var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_337862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7413 2H12.5962V0.471875C12.5962 0.223844 12.3386 0 12.0237 0C11.7088 0 11.4511 0.223844 11.4511 0.471875V2H4.58045V0.471875C4.58045 0.223844 4.3228 0 4.00789 0C3.69298 0 3.43533 0.223844 3.43533 0.471875V2H2.29022C1.02523 2 0 2.89531 0 4V14C0 15.1047 1.02523 16 2.29022 16H13.7413C15.0063 16 16.0316 15.1047 16.0316 14V4C16.0316 2.89531 15.0045 2 13.7413 2ZM2.29022 3H13.7413C14.3737 3 14.8864 3.44781 14.8864 4V5H1.14511V4C1.14511 3.44688 1.65791 3 2.29022 3ZM13.7413 15H2.29022C1.65791 15 1.14511 14.5522 1.14511 14V6H14.8864V14C14.8864 14.5531 14.3747 15 13.7413 15Z",
    fill: "#A1A4AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_337862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0316,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.52c1adbe7c8db58d68a7b63d1573516c.svg";
export { ForwardRef as ReactComponent };